module.exports = "/static/assets/807382b3f60d8eeebb10875a243c6bf8.gif";